import React from 'react';

/**
 * LayoutWrapper — Midnight Explorer dark shell.
 *
 * Wraps the entire authenticated app content in the dark
 * glassmorphism environment defined by the overhaul design system.
 *
 * Props:
 *   children — page content
 */
const LayoutWrapper = ({ children }) => {
  return (
    <div className="tw-min-h-screen tw-bg-surface tw-text-muted-fore tw-font-sans tw-antialiased">
      {/* Ambient gradient orbs — purely decorative, pointer-events none */}
      <div
        aria-hidden="true"
        className="tw-fixed tw-inset-0 tw-overflow-hidden tw-pointer-events-none tw-z-0"
      >
        {/* Top-left orb */}
        <div className="tw-absolute -tw-top-40 -tw-left-40 tw-w-96 tw-h-96 tw-rounded-full tw-bg-accent/10 tw-blur-3xl" />
        {/* Top-right orb */}
        <div className="tw-absolute -tw-top-20 -tw-right-20 tw-w-80 tw-h-80 tw-rounded-full tw-bg-secondary/10 tw-blur-3xl" />
        {/* Bottom-center orb */}
        <div className="tw-absolute tw-bottom-0 tw-left-1/2 -tw-translate-x-1/2 tw-w-[600px] tw-h-64 tw-rounded-full tw-bg-accent/5 tw-blur-3xl" />
      </div>

      {/* Scrollable content layer above orbs */}
      <div className="tw-relative tw-z-10 tw-flex tw-flex-col tw-min-h-screen">
        {children}
      </div>
    </div>
  );
};

export default LayoutWrapper;
